import { Leaf } from "lucide-react";
import { useLanguage } from "../i18n";

export const EditorialMarquee = () => {
  const { t } = useLanguage();
  const items = [...t.marquee, ...t.marquee, ...t.marquee];

  return (
    <section data-testid="editorial-marquee" className="overflow-hidden border-y border-[#062316]/10 bg-[#e9faf1] py-5">
      <div className="marquee-track" style={{ "--marquee-duration": "48s" }}>
        {[0, 1].map((half) => (
          <div key={half} className="flex shrink-0 items-center" aria-hidden={half === 1}>
            {items.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center">
                <span className="whitespace-nowrap px-8 font-display text-sm font-semibold uppercase tracking-[0.22em] text-[#0a2b1b]">
                  {item}
                </span>
                <Leaf size={14} className="shrink-0 text-[#1d8a52]" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </section>
  );
};
